import { ActionType, BaseAction } from "../common";

export namespace ReminderActionNs {
  type BindingValue = any;
  export const enum ReminderNotificationType {
    EMAIL = "email",
    LINE = "line",
    PUSH_NOTIFICATION = "push_notification",
  }

  export const enum ReminderNotificationScheduleType {
    IMMEDIATELY = "immediately",
    TIME_SCHEDULE = "time_schedule",
    TIME_SCHEDULE_DURATION = "time_schedule_duration",
    INTERVAL_DAY = "interval_day",
    INTERVAL_WEEK = "interval_week",
    INTERVAL_MONTH = "interval_month",
  }

  export const enum ReminderNotificationTimeDurationUnit {
    MINUTE = "minute",
    HOUR = "hour",
    DAY = "day",
    WEEK = "week",
  }
  export const enum ReminderNotificationIntervalUnit {
    HOUR = "hour",
    DAY = "day",
    WEEK = "week",
    MONTH = "month",
  }
  export type ImmediatelyType = {
    timeScheduleType: ReminderNotificationScheduleType.IMMEDIATELY;
  };
  export type TimeSchedule = {
    timeScheduleType: ReminderNotificationScheduleType.TIME_SCHEDULE;
    timeSchedule: BindingValue;
  };
  export type TimeScheduleDuration = {
    timeScheduleType: ReminderNotificationScheduleType.TIME_SCHEDULE_DURATION;
    timeScheduleRelationUnit: ReminderNotificationTimeDurationUnit;
    timeScheduleRelationValue: BindingValue; // Reminder will be run before
    timeScheduleRelationFromValue?: BindingValue;
  } | {
    timeScheduleType: ReminderNotificationScheduleType.TIME_SCHEDULE_DURATION;
    timeScheduleRelationUnit: ReminderNotificationTimeDurationUnit.DAY;
    timeScheduleRelationValue: BindingValue;
    timeScheduleRelationFromValue?: BindingValue; // Reminder will be run before
    timeScheduleRelationTimeValue: BindingValue; // only work when timeScheduleRelationUnit = Day
  };
  export type IntervalDayType = {
    timeScheduleType: ReminderNotificationScheduleType.INTERVAL_DAY;
    timeScheduleIntervalTimeValue: BindingValue;
  };
  export const enum WeekDay {
    MONDAY = "Monday",
    TUESDAY = "Tuesday",
    WEDNESDAY = "Wednesday",
    THURSDAY = "Thursday",
    FRIDAY = "Friday",
    SATURDAY = "Saturday",
    SUNDAY = "Sunday",
  }
  export type IntervalWeekType = {
    timeScheduleType: ReminderNotificationScheduleType.INTERVAL_WEEK;
    timeScheduleIntervalWeekDayValue: WeekDay[];
    timeScheduleIntervalTimeValue: BindingValue;
  };
  export type IntervalMonthType = {
    timeScheduleType: ReminderNotificationScheduleType.INTERVAL_MONTH;
    timeScheduleIntervalMonthDayValue: BindingValue;
    timeScheduleIntervalTimeValue: BindingValue;
  };
  export type TimeScheduleType =
    | ImmediatelyType
    | TimeSchedule
    | TimeScheduleDuration
    | IntervalDayType
    | IntervalWeekType
    | IntervalMonthType;

  export type EmailActionType = {
    type: ReminderNotificationType.EMAIL;
    action: {
      options: {
        address: BindingValue;
        title: BindingValue;
        body: BindingValue;
      };
    };
  };
  export type LineActionType = {
    type: ReminderNotificationType.LINE;
    action: {
      options: {
        title: BindingValue;
        channelAccessToken: BindingValue;
      } & (
        | {
          listUser: "all";
        }
        | {
          listUser: "specific";
          field: string;
          comparator: BindingValue;
          comparison: BindingValue;
          comparison2?: BindingValue;
        }
      );
    };
  };

  export type PushNotificationActionType = {
    type: ReminderNotificationType.PUSH_NOTIFICATION;
    action: {
      options: {
        title: BindingValue;
        sendApp: string;
        openPage: string;
      } & (
        | {
          listUser: "all";
        }
        | {
          listUser: "specific";
          field: string;
          comparator: BindingValue;
          comparison: BindingValue;
          comparison2?: BindingValue;
        }
      );
    };
  };
  export type ActionType =
    | EmailActionType
    | LineActionType
    | PushNotificationActionType;

  export type ReminderActionOptions = ActionType & TimeScheduleType;
}

export type ReminderNotificationAction = BaseAction & {
  actionType: ActionType.REMINDER_NOTIFICATION;
  options: ReminderActionNs.ReminderActionOptions;
};